import { useCallback, useEffect, useRef, useState } from 'react';
import { api, API } from './api';

export const passportTabs = ['Overview', 'Development', 'Metrics', 'Trainers', 'Links'];
export const passportError = error => {
  const detail = error.response?.data?.detail;
  return typeof detail === 'string' ? detail : Array.isArray(detail)
    ? detail.map(item => item.msg.replace(/^Value error, /, '')).join('. ')
    : 'This Passport could not be updated. Please try again.';
};
export const passportMedia = endpoint => fileId => fileId ? `${API}${endpoint}/media/${fileId}` : undefined;
export const goalStatuses = { planned: 'Planned', in_progress: 'In Progress', achieved: 'Achieved' };

export function usePlayerPassport(endpoint) {
  const [data, setData] = useState(null);
  const [error, setError] = useState('');
  const request = useRef(0);
  const cancelPending = useCallback(() => { request.current++; }, []);
  const load = useCallback(async () => {
    const sequence = ++request.current;
    try {
      const result = await api.get(endpoint);
      if (sequence === request.current) { setData(result.data); setError(''); }
    } catch (e) {
      if (sequence === request.current) { setData(null); setError(passportError(e)); }
    }
  }, [endpoint]);
  useEffect(() => {
    setData(null); setError(''); load();
    const visible = () => { if (document.visibilityState === 'visible') load(); };
    window.addEventListener('focus', load);
    document.addEventListener('visibilitychange', visible);
    return () => { cancelPending(); window.removeEventListener('focus', load); document.removeEventListener('visibilitychange', visible); };
  }, [load, cancelPending]);
  return { data, error, load };
}